package app.nestbridge.feature.common.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import app.nestbridge.feature.common.screen.DocumentViewerEvent
import app.nestbridge.feature.common.screen.DocumentViewerScreen
import app.nestbridge.feature.common.screen.DocumentViewerState
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import kotlinx.coroutines.launch
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import nestbridge.composeapp.generated.resources.Res
import org.jetbrains.compose.resources.ExperimentalResourceApi
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = DocumentViewerScreen::class,
    scope = AppScope::class,
)
@Inject
class DocumentViewerPresenter(
    @Assisted private val screen: DocumentViewerScreen,
    @Assisted private val navigator: Navigator,
) : Presenter<DocumentViewerState> {

    @OptIn(ExperimentalResourceApi::class)
    @Composable
    override fun present(): DocumentViewerState {
        val scope = rememberCoroutineScope()

        var state by remember {
            mutableStateOf(
                DocumentViewerState(
                    title = screen.document.title,
                    isLoading = true,
                ),
            )
        }

        fun loadContent() {
            scope.launch {
                val text = runCatching {
                    Res.readBytes(screen.document.resourcePath).decodeToString()
                }.getOrElse { "Unable to load document. Please try again later." }

                state = state.copy(
                    content = text,
                    isLoading = false,
                )
            }
        }

        fun onEvent(event: DocumentViewerEvent) {
            when (event) {
                DocumentViewerEvent.OnAppear -> loadContent()
                DocumentViewerEvent.Close -> navigator.pop()
            }
        }

        return state.copy(
            eventSink = ::onEvent,
        )
    }
}
